import React, { useRef } from 'react';
import ReactDOM from 'react-dom';

import { Map, TileLayer, GeoJSON } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';

import { numberFormat } from '../../helper/MaskHelper';

import brStates from '../../assets/maps/brazil-states-geojson.json';

export const MapaBrasil = ({ ufs }) => {
    const mapRef = useRef(null);

    const center = [ -15.2350, -53.9253 ];
    const zoom = 5;

    const focusHighlight = (e) => e.target.setStyle({ weight: 4, fillOpacity: 0.8 });
    const resetHighlight = (e) => e.target.setStyle(getCssNormal(e.target.feature));

    const getCssNormal = (feature) => {
        let color = '#F7B034';

        switch (feature.properties.regiao_id) {
            case '1': color = '#AD9FCB'; break; // SUL
            case '2': color = '#DB9EC0'; break; // SUDESTE
            case '3': color = '#A4CD56'; break; // NORTE
            case '4': color = '#FDD40A'; break; // NORDESTE
            case '5': color = '#F9955A'; break; // CENTRO-OESTE
            default: break;
        } 

        return { color: color, weight: 2, fillOpacity: 0.3, fillColor: color };
    };

    const handleMapClick = () => mapRef.current.leafletElement.setView(center, zoom);

    return (
        <>
            {ufs.length > 0 && 
                <Map 
                    center={center} 
                    zoom={zoom} 
                    style={{ width: '100%', height: '950px' }}
                    scrollWheelZoom={false}
                    doubleClickZoom={false}
                    zoomControl={false}
                    touchZoom={false}
                    keyboard={false}
                    dragging={false}
                    ref={mapRef}
                    onClick={handleMapClick}
                >
                    <TileLayer
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    />

                    <GeoJSON
                        data={brStates}
                        style={getCssNormal}
                        onEachFeature={(feature, layer) => {
                            const uf = ufs.find(uf => uf.uf === feature.properties.sigla);
                            
                            if (uf) {
                                const popup = document.createElement('div');
                                ReactDOM.render(<StatePopup name={feature.properties.name} uf={uf} />, popup);
                                layer.bindPopup(popup);

                                layer.on({ mouseover: focusHighlight, mouseout: resetHighlight });
                            }
                        }}
                    />
                </Map>
            }
        </>
    );
};

const StatePopup = ({ uf, name }) => {
    return (
        <div>
            <h3 style={{ textAlign: "center" }}><b>{name}</b></h3>
            <br />

            <div>
                Candidatos: <b>{numberFormat(uf.candidatos)}</b><br />
                Inscrições Finalizadas: <b>{numberFormat(uf.candidatosInscritos)}</b><br />
                Inscrições Aguardando Pagamento: <b>{numberFormat(uf.candidatosAguardandoPagamento)}</b><br />
                Inscrições Com Pendências: <b>{numberFormat(uf.candidatosComPendencias)}</b><br />
                Inscrições Não Finalizadas: <b>{numberFormat(uf.candidatosNaoFinalizados)}</b><br /> 
                Municipios Inscritos: <b>{numberFormat(uf.municipios)}</b><br />
            </div>
        </div>
    );
};

export default MapaBrasil;
